import React, { useState } from "react";

const SustainabilityReporting = () => {
  const [currentPage, setCurrentPage] = useState(0);
  const [selectedFile, setSelectedFile] = useState(null);
  const [formData, setFormData] = useState({
    legalForm: "",
    natureofOwnership: "",
    headquarters: "",
    countriesOfOperation: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  //   Page buttons
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
    window.scrollTo(0, 0);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
    window.scrollTo(0, 0);
  };

  // form contents
  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Handle form submission or file upload logic here
  };

  return (
    <div className="container ">
      {/* <h1 className="mx-4 pt-4 font-semibold">2.2</h1> */}
      <div className="flex justify-between">
        <h1 className="mx-4 pb-8 text-gray-500 text-xl font-bold">
          Entities Included in the Organization's Sustainability Reporting{" "}
        </h1>
        <h3 className="text-end mx-8 bg-gray-200 font-bold text-sm h-[3%] border-4 h-12">
          GRI 2-2
        </h3>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                {" "}
                List all entities included in the sustainability report
              </h2>
            </label>
            <input
              type="text"
              id="legalForm"
              placeholder="Enter a text"
              autocomplete="off"
              name="legalForm"
              className=" mt-2 p-2 border rounded-md w-full "
              value={formData.legalForm}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className=" items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Does the organization have audited, consolidated financial
                statements or financial information filed on public record?
              </h2>
            </label>
            <select
              // id="natureofOwnership"
              name="natureofOwnership"
              className="mt-2 p-2 border rounded-md w-full"
              // value={formData.natureofOwnership}
              // onChange={handleInputChange}
            >
              <option value="select">- Select - </option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                If yes, then please specify the differences between the list of
                entities included in the financial reporting and the list
                included in the sustainability reporting.
              </h2>
            </label>
            <input
              type="text"
              id="headquarters"
              name="headquarters"
              placeholder="Enter a text"
              autocomplete="off"
              className="mt-2 p-2 border rounded-md w-full"
              value={formData.headquarters}
              onChange={handleInputChange}
            />
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                Does the organization consist of multiple entities?
              </h2>
            </label>
            <select
              id="natureofOwnership"
              name="natureofOwnership"
              className="mt-2 p-2 border rounded-md w-full"
              value={formData.natureofOwnership}
              onChange={handleInputChange}
            >
              <option value="select">- Select - </option>
              <option value="yes">Yes</option>
              <option value="no">No</option>
            </select>
          </div>
        </div>
        <div className="flex items-center mx-4 pb-2 mb-4">
          <div className="w-full mr-2">
            <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
              <h2 className="text-gray-600">
                "If yes, then explain the approach used for consolidating
                information. Please include - - whether the approach involves
                adjustments to information for minority interests - how the
                approach takes into account mergers, acquisitions and disposal
                of entities or parts of entities - whether and how the approach
                differs across the disclosures within GRI Standards and across
                material topics"
              </h2>
            </label>
            <textarea
              id="countriesOfOperation"
              name="countriesOfOperation"
              placeholder="Enter a text"
              className="mt-2 p-2 border rounded-md w-full"
              value={formData.countriesOfOperation}
              onChange={handleInputChange}
              rows={4} // Specify the number of rows to determine the initial height
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default SustainabilityReporting;
